/*
* Formats dollar amounts for a specific distribution line field
* @param {VueComponent} self
* @param {Object} coordinates
*/
export function formatDistributionLineMoneyFields (self, coordinates) {
  const { lineIndex, fieldName } = coordinates
  if (self.lines &&
    self.lines[lineIndex] &&
    self.lines[lineIndex].hasOwnProperty('form') &&
    self.lines[lineIndex].form &&
    self.lines[lineIndex].form[fieldName]) {
    const val = self.lines[lineIndex].form[fieldName].value
    if (val !== null && val !== '') self.lines[lineIndex].form[fieldName].value = Number(val).toFixed(2)
  }
}
